import _objectWithoutProperties from "/Users/laurogripa/code/kusama/kappasigmamu.github.io/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["url", "distance", "loop", "autoplay"];
import _extends from '@babel/runtime/helpers/esm/extends';
import * as React from 'react';
import { AudioListener, AudioLoader } from 'three';
import { useThree, useLoader } from '@react-three/fiber';
import mergeRefs from 'react-merge-refs';
const PositionalAudio = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      url,
      distance = 1,
      loop = true,
      autoplay
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const sound = React.useRef();
  const camera = useThree(_ref2 => {
    let {
      camera
    } = _ref2;
    return camera;
  });
  const [listener] = React.useState(() => new AudioListener());
  const buffer = useLoader(AudioLoader, url);
  React.useEffect(() => {
    const _sound = sound.current;
    if (_sound) {
      _sound.setBuffer(buffer);
      _sound.setRefDistance(distance);
      _sound.setLoop(loop);
      if (autoplay && !_sound.isPlaying) _sound.play();
    }
  }, [buffer, camera, distance, loop]);
  React.useEffect(() => {
    const _sound = sound.current;
    camera.add(listener);
    return () => {
      camera.remove(listener);
      if (_sound) {
        if (_sound.isPlaying) _sound.stop();
        if (_sound.source && _sound.source._connected) _sound.disconnect();
      }
    };
  }, []);
  return /*#__PURE__*/React.createElement("positionalAudio", _extends({
    ref: mergeRefs([sound, ref]),
    args: [listener]
  }, props));
});
export { PositionalAudio };